import React, { FC } from 'react';
import notFoundImg from 'assets/images/not-found.svg';
import { Link } from 'react-router-dom';


const P4P404Page: FC = () => {

    return (
        <div className='container'>
            <div className='section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center'>
                <h1>404</h1>
                <h2>The page you are looking for doesn't exist.</h2>
                <Link to='/' className="btn" >Back to Available Dogs</Link>
                <img src={notFoundImg} className="img-fluid py-5" alt="Page Not Found"></img>

            </div>
        </div>
    )
}

export default P4P404Page;




















